// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toc-wide-variant":"_35LMwk","bottom":"_3b4A0s","hideDesktop":"_3jVauU","hideNotDesktop":"_2Hf8vL"};